module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_RU.f5fb6071.txt";